/**
 * Tipos de documento gerado de uma licitação (`procurement_generated_documents.type`): rótulo e grupo na tela.
 *
 * Eram dois mapas, um na DocumentosSection e outro no ProcessDocumentsCard, e os dois vestiam QUALQUER tipo que não
 * conheciam de "Declaração" (e o agrupavam em "Declarações"). Um recurso administrativo gerado pelo HUB apareceria
 * como declaração, no grupo das sete a dez declarações de rotina, que é onde ninguém procura um prazo recursal.
 * (07/10/2026)
 *
 * Regra do desconhecido: tipo que o front não conhece vai para "Outros documentos", rotulado com o próprio `type`
 * cru. Dizer o nome que o banco deu é melhor que inventar um.
 *
 * Sem `type` é outra coisa: a coluna é NOT NULL com default 'declaracao' no backend, então um documento sem tipo só
 * existe em objeto montado no front, e o banco o chamaria de declaração. Esse continua "Declaração".
 */

export const DOC_TIPO: Record<string, string> = {
  proposta_financeira: 'Proposta Financeira',
  recurso: 'Recurso',
  declaracao: 'Declaração',
  peca_tecnica: 'Peça Técnica',
  pacote_assinatura: 'Pacote de Assinatura',
};

/** Grupo dos tipos que o front não conhece. */
export const GRUPO_OUTROS = 'outros';

/**
 * Ordem dos grupos na lista: o que se mexe mais vem primeiro. Recurso vem logo depois da proposta: quando existe,
 * corre contra prazo recursal. Declarações são volume (7 a 10 por licitação) e ficam abaixo; pacote de assinatura é
 * consequência. O desconhecido fecha a lista.
 */
export const GRUPOS: Array<{ tipo: string; titulo: string }> = [
  { tipo: 'proposta_financeira', titulo: 'Proposta' },
  { tipo: 'recurso', titulo: 'Recursos' },
  { tipo: 'peca_tecnica', titulo: 'Comprovações e peças' },
  { tipo: 'declaracao', titulo: 'Declarações' },
  { tipo: 'pacote_assinatura', titulo: 'Pacotes de assinatura' },
  { tipo: GRUPO_OUTROS, titulo: 'Outros documentos' },
];

/** O grupo de um documento pelo `type`. Desconhecido → "Outros documentos", nunca "Declarações". */
export const grupoDe = (tipo?: string | null): string => {
  if (!tipo) return 'declaracao';
  return tipo in DOC_TIPO ? tipo : GRUPO_OUTROS;
};

/** O rótulo de um documento pelo `type`. Desconhecido → o próprio `type`, nunca "Declaração". */
export const rotuloDoTipo = (tipo?: string | null): string => {
  if (!tipo) return DOC_TIPO.declaracao;
  return DOC_TIPO[tipo] || tipo;
};
